/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface BulkImportFacilityServiceAreasResponseErrorsInner
 */
export interface BulkImportFacilityServiceAreasResponseErrorsInner {
    /**
     * 
     * @type {number}
     * @memberof BulkImportFacilityServiceAreasResponseErrorsInner
     */
    row: number;
    /**
     * 
     * @type {string}
     * @memberof BulkImportFacilityServiceAreasResponseErrorsInner
     */
    zip?: string;
    /**
     * 
     * @type {string}
     * @memberof BulkImportFacilityServiceAreasResponseErrorsInner
     */
    error: string;
}

/**
 * Check if a given object implements the BulkImportFacilityServiceAreasResponseErrorsInner interface.
 */
export function instanceOfBulkImportFacilityServiceAreasResponseErrorsInner(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "row" in value;
    isInstance = isInstance && "error" in value;

    return isInstance;
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerFromJSON(json: any): BulkImportFacilityServiceAreasResponseErrorsInner {
    return BulkImportFacilityServiceAreasResponseErrorsInnerFromJSONTyped(json, false);
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): BulkImportFacilityServiceAreasResponseErrorsInner {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'row': json['row'],
        'zip': !exists(json, 'zip') ? undefined : json['zip'],
        'error': json['error'],
    };
}

export function BulkImportFacilityServiceAreasResponseErrorsInnerToJSON(value?: BulkImportFacilityServiceAreasResponseErrorsInner | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'row': value.row,
        'zip': value.zip,
        'error': value.error,
    };
}

